import React from 'react';
import Element from '../components/Element'

export default function ElementsField({ elfield, params, click_element, boubleClick, clickPlus, clickMinus, longTouch, touchend, ui_language}){    
    
    let cnt_elements = 0;
    let current_field_type = elfield.field_type
    let current_field_id = elfield.field_id
    let current_field_name = ''
    let current_config = elfield.ui_cfg
    let current_elements = current_config.ui_items
    let ui_elements = [];
    let page_content = []
    let pg_cnt_i = 0

    if (current_field_type === 'room') {
        let room_array = elfield.ui_cfg.ui_rooms;
        for (let index = 0; index < room_array.length; index++) {
            if (room_array[index].ui_room_id === current_field_id) current_field_name = room_array[index].ui_room_name;   
        }
    }
    else if (current_field_type === 'category') {
        let cat_array = elfield.ui_cfg.ui_categories;
        for (let index = 0; index < cat_array.length; index++) {
            if (cat_array[index].ui_category_id === current_field_id) current_field_name = cat_array[index].ui_category_name;   
        }
    }

    if (current_field_type === 'room'){
        for (let j = 0; j < current_config.ui_categories.length; j++) {
            let field_name = current_config.ui_categories[j].ui_category_name
            let field_id = current_config.ui_categories[j].ui_category_id
            cnt_elements = 0;
            ui_elements = [];
            for (let i = 0; i < current_elements.length; i++) {
                if ((current_elements[i].ui_room_id === current_field_id)&&(current_elements[i].ui_category_id === field_id)){
                    ui_elements[cnt_elements] = current_elements[i];
                    cnt_elements++;
                }
            }
            if (ui_elements.length > 0){
                page_content[pg_cnt_i] = {pg_cnt_name: field_name, pg_cnt_arr: ui_elements}
                pg_cnt_i++
            }
        }
    }
    else if (current_field_type === 'category'){
        for (let j = 0; j < current_config.ui_rooms.length; j++) {
            let field_name = current_config.ui_rooms[j].ui_room_name
            let field_id = current_config.ui_rooms[j].ui_room_id
            cnt_elements = 0;
            ui_elements = [];
            for (let i = 0; i < current_elements.length; i++) {
                if ((current_elements[i].ui_category_id === current_field_id)&&(current_elements[i].ui_room_id === field_id)){
                    ui_elements[cnt_elements] = current_elements[i];
                    cnt_elements++;
                }
            }
            if (ui_elements.length > 0){
                page_content[pg_cnt_i] = {pg_cnt_name: field_name, pg_cnt_arr: ui_elements}
                pg_cnt_i++
            }
        }
    }

    return(
        <div className="elementsField">
            <div className="content-top">{current_field_name}</div>
            <div className="l-wrap_container">
            { page_content.map( page_content => {
                return  <div className="l-wrap">
                            <div className="field_name">{page_content.pg_cnt_name}</div>
                            <div className="three-col-grid">
                                { page_content.pg_cnt_arr.map( ui_element => {
                                    return <div className="grid-item">
                                        <Element ui_element={ui_element} key={ui_element.ui_item_id} params={params} click={click_element} boubleClick={boubleClick} current_field_type={current_field_type} clickPlus={clickPlus} clickMinus={clickMinus} longTouch={longTouch} touchend={touchend} ui_language={ui_language}/>
                                        </div>
                                })}
                            </div>
                        </div>
                    
            })}
            </div>
        </div>
    )
}